import React, { Component } from 'react';
import { connect } from 'react-redux';

import AddVariant from './AddVariant';
import LoadingIcon from '../../../common/icons/LoadingIcon';
import VariantLineItem from './VariantLineItem';

import styles from './_styles/EditSectionBlock.module.scss';

const allActionCreators = Object.assign({});

export class EditSectionVariants extends Component {

	constructor(props) {
	
		super(props);
	
		this.state = {
			addOpen: false,
		};
	}

	getOrderedVariants() {
		if(!this.props.product?.variants) { return []; }
		
		const sortedVariants = this.props.product.variants
			.slice() // copy so we don’t mutate props
			.sort((a, b) => {
				// normalize and detect empties
				const wa = a.gold_weight  == null || a.gold_weight  === "" 
						? null 
						: a.gold_weight.toString().toLowerCase();
				const wb = b.gold_weight  == null || b.gold_weight  === "" 
						? null 
						: b.gold_weight.toString().toLowerCase();

				// 1) any “empty” goes last
				if (wa === null && wb !== null) return  1;
				if (wa !== null && wb === null) return -1;

				// 2) both non-empty? compare ascending
				if (wa !== null && wb !== null) {
				const wcmp = wa.localeCompare(wb, undefined, { sensitivity: "base" });
				if (wcmp !== 0) return wcmp;
				}

				// 3) tie or both empty: compare color descending
				const ca = (a.gold_color  || "").toString().toLowerCase();
				const cb = (b.gold_color  || "").toString().toLowerCase();
				return cb.localeCompare(ca, undefined, { sensitivity: "base" });
			});
		
		return sortedVariants;
	}

	setAddOpen(val) {
		this.setState({ addOpen: !!val });
	}
	
	render() {
		return <div className={`${styles.EditSectionBlock}`}>
			<div className={styles.titleWrapper}>
				<div className={styles.title}>Variant</div>
			</div>
			<div className={styles.body}>

				{!this.props.product 
					?	<div className={styles.noProductSpacer}></div>
					:	<>
							{this.getOrderedVariants().length > 0
								?	<div className={styles.variantsWrapper}>
										{this.getOrderedVariants().map((vnt, i) => {
											return <VariantLineItem
														key={vnt.id}
														product={this.props.product}
														variant={vnt}
														refresh={this.props.refresh} />
										})}
										
										<div className={styles.addRow}>
											{!this.state.addOpen && (<div className={styles.addLink} onClick={() => this.setAddOpen(true)}>Add New Variant</div>)}
										</div>
										
									</div>
								:	<div className={styles.noVariants}>
										<div className={styles.copy}>No product variants</div>
										{!this.state.addOpen && (
											<div className={styles.add} onClick={() => this.setAddOpen(true)}>Add</div>
										)}
									</div>
							}
						</>
				}

				{this.state.addOpen && (
					<div className={styles.addWrapper}>
						<AddVariant
							product={this.props.product}
							setOpen={this.setAddOpen.bind(this)}
							refresh={this.props.refresh} />
					</div>
				)}
				
				{this.props.loading && (
					<div className={styles.loadingWrapper}>
						<div className={styles.iconWrapper}>
							<LoadingIcon />
						</div>
					</div>
				)}
			</div>
		</div>;
	}
}

function mapStateToProps(state) {
	return {

	};
}

export default connect(mapStateToProps, allActionCreators)(EditSectionVariants);